"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __values = this && this.__values || function (o) {
  var m = typeof Symbol === "function" && o[Symbol.iterator],
      i = 0;
  if (m) return m.call(o);
  return {
    next: function next() {
      if (o && i >= o.length) o = void 0;
      return {
        value: o && o[i++],
        done: !o
      };
    }
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = require("react");

var semantic_ui_react_1 = require("semantic-ui-react");

var context_1 = require("../context");

var data_1 = require("../data");

var InfoPanelClass =
/** @class */
function (_super) {
  __extends(InfoPanelClass, _super);

  function InfoPanelClass(props) {
    return _super.call(this, props) || this;
  }

  InfoPanelClass.prototype.render = function () {
    var _this = this;

    var _a = this.props,
        data = _a.data,
        height = _a.height,
        residueContext = _a.residueContext,
        width = _a.width,
        secondaryStructureContext = _a.secondaryStructureContext;
    var unassignedResidues = data.pdbData ? this.renderUnassignedResidues(data.pdbData) : [React.createElement(semantic_ui_react_1.Label, {
      key: 'unassigned-residues-none'
    })];
    return React.createElement("div", {
      className: "InfoPanel",
      style: {
        height: height,
        width: width
      }
    }, React.createElement(semantic_ui_react_1.Accordion, {
      exclusive: false,
      panels: [data.pdbData && data.pdbData.secondaryStructureSections.map(function (secondaryStructure) {
        return {
          content: _this.renderSecondaryStructures(secondaryStructure),
          key: 'all-secondary-structures',
          title: "All Secondary Structures (" + (data.pdbData ? data.pdbData.secondaryStructureSections.length : 0) + "):"
        };
      }), {
        content: unassignedResidues,
        key: 'unassigned-residues',
        title: "Unassigned Residues (" + unassignedResidues.length + "):"
      }, {
        content: this.renderSecondaryStructures(secondaryStructureContext.selectedSecondaryStructures),
        key: 'selected-secondary-structures',
        title: "Selected Secondary Structures (" + secondaryStructureContext.selectedSecondaryStructures.length + "):"
      }, {
        content: this.renderLockedResiduePairs(residueContext.lockedResiduePairs),
        key: 'selected-residue-pairs',
        title: "Selected Residue Pairs (" + residueContext.lockedResiduePairs.size + "):"
      }]
    }));
  };

  InfoPanelClass.prototype.renderLockedResiduePairs = function (lockedResiduePairs) {
    return lockedResiduePairs.size === 0 ? [React.createElement(semantic_ui_react_1.Label, {
      key: 'locked-residue-pair-none'
    }, "None")] : Array.from(lockedResiduePairs.values()).map(function (pair, index) {
      return React.createElement(semantic_ui_react_1.Label, {
        key: "locked-residue-pair-" + index
      }, pair.join(', '));
    });
  };

  InfoPanelClass.prototype.renderSecondaryStructures = function (selectedSecondaryStructures) {
    return selectedSecondaryStructures.length === 0 ? [React.createElement(semantic_ui_react_1.Label, {
      key: 'sec-struct-none'
    }, "None")] : selectedSecondaryStructures.map(function (section, index) {
      return React.createElement(semantic_ui_react_1.Label, {
        key: "sec-struct-" + index
      }, "[" + section.start + "-" + section.end + "]: " + section.label + " - " + data_1.SECONDARY_STRUCTURE_CODES[section.label]);
    });
  };

  InfoPanelClass.prototype.renderUnassignedResidues = function (pdbData) {
    var result = new Array();
    pdbData.eachResidue(function (residue) {
      var e_1, _a, e_2, _b;

      if (residue.isProtein()) {
        var isUnassigned = true;

        try {
          for (var _c = __values(pdbData.secondaryStructureSections), _d = _c.next(); !_d.done; _d = _c.next()) {
            var secondaryStructure = _d.value;

            try {
              for (var secondaryStructure_1 = __values(secondaryStructure), secondaryStructure_1_1 = secondaryStructure_1.next(); !secondaryStructure_1_1.done; secondaryStructure_1_1 = secondaryStructure_1.next()) {
                var section = secondaryStructure_1_1.value;

                if (section.contains(residue.resno)) {
                  isUnassigned = false;
                  break;
                }
              }
            } catch (e_2_1) {
              e_2 = {
                error: e_2_1
              };
            } finally {
              try {
                if (secondaryStructure_1_1 && !secondaryStructure_1_1.done && (_b = secondaryStructure_1.return)) _b.call(secondaryStructure_1);
              } finally {
                if (e_2) throw e_2.error;
              }
            }
          }
        } catch (e_1_1) {
          e_1 = {
            error: e_1_1
          };
        } finally {
          try {
            if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
          } finally {
            if (e_1) throw e_1.error;
          }
        }

        if (isUnassigned) {
          result.push(React.createElement(semantic_ui_react_1.Label, {
            key: "unassigned-residue-" + residue.resno
          }, "[" + residue.resno + ": isCg? " + residue.isCg() + ",               isDna? " + residue.isDna() + ",               isHelix? " + residue.isHelix() + ",               isNucleic? " + residue.isNucleic() + ",               isProtein? " + residue.isProtein() + ",               isPolymer? " + residue.isPolymer() + ",               isSaccharide? " + residue.isSaccharide() + ",               isSheet? " + residue.isSheet() + ",              isTurn? " + residue.isTurn(), "}"));
        }
      }
    });
    return result;
  };

  InfoPanelClass.defaultProps = {
    data: {
      couplingScores: new data_1.CouplingContainer(),
      secondaryStructures: new Array()
    },
    height: 400,
    residueContext: __assign({}, context_1.initialResidueContext),
    secondaryStructureContext: __assign({}, context_1.initialSecondaryStructureContext),
    width: 400
  };
  return InfoPanelClass;
}(React.Component);

exports.InfoPanelClass = InfoPanelClass;

var InfoPanel = function InfoPanel(props) {
  return React.createElement(context_1.SecondaryStructureContext.Consumer, null, function (secStructContext) {
    return React.createElement(context_1.ResidueContext.Consumer, null, function (residueContext) {
      return React.createElement(InfoPanel, __assign({}, props, residueContext, secStructContext));
    });
  });
};

exports.InfoPanel = InfoPanel;